import type { ComponentProps } from "react";

import { ContactMapCard } from "@widgets/contact-map-card";
import { PageHero } from "@widgets/page-hero";

import { Container } from "@shared/ui/container";

import { InfoSection } from "@/_pages/instructors/ui/info";

import type { VacancyListType, VacancyPageType } from "../model";
import { VacancyTable } from "./vacancy-table";

import s from "./vacancy-page.module.scss";

export type VacancyPageProps = ComponentProps<"main"> & {
  pageData: VacancyPageType;
  vacancyList: VacancyListType;
};

export const VacancyPage = (props: VacancyPageProps) => {
  const { pageData, vacancyList } = props;

  return (
    <main className={s.root}>
      {pageData?.titleWithIcon && (
        <PageHero
          variant="primary"
          textColor="brown"
          title={pageData?.titleWithIcon}
        />
      )}
      {pageData?.info && (
        <InfoSection info={pageData.info} className={s.info} />
      )}
      {vacancyList?.length > 0 && (
        <Container tag="section">
          <VacancyTable vacancyList={vacancyList} />
        </Container>
      )}
      {pageData?.contactMapSection && (
        <Container tag="section" className={s.mapContainer}>
          <ContactMapCard {...pageData.contactMapSection} />
        </Container>
      )}
    </main>
  );
};

VacancyPage.displayName = "VacancyPage";
